import { render } from "./RedeChatView.vue?vue&type=template&id=6462cb20&scoped=true"
import script from "./RedeChatView.vue?vue&type=script&lang=js"
export * from "./RedeChatView.vue?vue&type=script&lang=js"

import "./RedeChatView.vue?vue&type=style&index=0&id=6462cb20&lang=scss"
import "./RedeChatView.vue?vue&type=style&index=1&id=6462cb20&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6462cb20"]])

export default __exports__